import React from 'react';
import { CheckCircle, Phone, Home } from 'lucide-react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../utils/mockData';

const ThankYou = () => {
  return (
    <div className="min-h-screen">
      <section className="py-14">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <div className="bg-green-100 w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-8">
              <CheckCircle className="text-green-600" size={56} />
            </div>

            <h1 className="text-4xl md:text-5xl font-bold text-brand-blue mb-6" data-testid="thank-you-heading">
              Thank You!
            </h1>

            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Purposefully Covered Insurance Group received your request. A licensed representative will contact you soon at the phone number or email provided.
            </p>

            <div className="bg-gray-50 rounded-lg p-8 mb-12">
              <h2 className="text-2xl font-bold text-brand-blue mb-4">What Happens Next?</h2>
              <div className="space-y-4 text-left">
                {[
                  { step: 1, title: "We'll Review Your Information", desc: "Our team will carefully review your submission to understand your insurance needs." },
                  { step: 2, title: "Expect A Call Within 24 Hours", desc: "A licensed agent will reach out to discuss your options and answer any questions." },
                  { step: 3, title: "Get Personalized Recommendations", desc: "We'll provide tailored coverage options that fit your needs and budget." },
                ].map(item => (
                  <div key={item.step} className="flex items-start gap-4">
                    <div className="bg-brand-blue text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                      {item.step}
                    </div>
                    <div>
                      <h3 className="font-bold text-lg text-brand-blue mb-1">{item.title}</h3>
                      <p className="text-gray-700">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-brand-blue text-white rounded-lg p-8 mb-8">
              <h3 className="text-2xl font-bold mb-4">Need Immediate Assistance?</h3>
              <p className="mb-6">If you have urgent questions, give us a call.</p>
              <a
                href={`tel:${companyInfo.phoneRaw}`}
                className="inline-flex items-center gap-2 bg-brand-orange text-white px-8 py-4 rounded-md hover:bg-brand-orange-light transition font-semibold text-lg"
                data-testid="thank-you-call-btn"
              >
                <Phone size={20} />
                {companyInfo.phone}
              </a>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/"
                className="inline-flex items-center justify-center gap-2 bg-gray-200 text-brand-blue px-8 py-3 rounded-md hover:bg-gray-300 transition font-semibold"
              >
                <Home size={20} /> Return to Homepage
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 bg-brand-blue text-white px-8 py-3 rounded-md hover:bg-brand-orange transition font-semibold"
              >
                Learn More About Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ThankYou;
